export enum AppIds {
    Slack = "slack",
    Web = "web",
}